import { LocalNotificationsPluginWeb } from '@capacitor/core';
import {RolesList} from '@gtpl/shared-models/gtpl';
export class CreateUserDto {
    Id?: number;
    username:string;
    password?:string;
    email:string;
    role:RolesList;
    employeeId:number;
    status: boolean;
    createdAt : Date | any;
    createdUser : number;
    updatedAt : Date | any;
    updatedUser : number;
    versionFlag : number;
    id?:number;
  }
  
  export const CreateUserDtoDefault : CreateUserDto = {
    Id: 0,
    username:"",
    password:"",
    role:RolesList.LTWO,
    email:"",
    employeeId:1,    
    status: true,
    createdAt : new Date() ,
    createdUser : 0,
    updatedAt : new Date() ,
    updatedUser : 0,
    versionFlag : 1,
    id: 0
  };
  
  